import React, { useCallback } from 'react';
import { Container, Row } from 'reactstrap';
import classNames from 'classnames';
import './styles.css';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import * as ROUTES from '../../constants/routes';
import SignInBody from '../../components/elements/customModals/SignInModalForm/SignInBody';
import { IS_SIDEKICK_APP } from '../../constants/projects';

const SignInPage = () => {
    const history = useHistory();

    const handleRedirectToSignUp = useCallback(() => {
        history.push(ROUTES.SIGN_UP);
    }, [history]);

    const handleRedirectToForgotPassword = useCallback(() => {
        history.push(ROUTES.RESET_PASSWORD);
    }, []);

    return (
        <div
            className={classNames('unauthorized-sign-in__container', {
                'unauthorized-sign-in__container--sidekick': IS_SIDEKICK_APP,
            })}
        >
            <Container>
                <Row className="unauthorized-sign-in">
                    <div className="unauthorized-sign-in__popup">
                        <h5 className="unauthorized-sign-in__popup-title">
                            {IS_SIDEKICK_APP ? 'Sign in to your Sidekick Network' : 'Sign-In'}
                        </h5>
                        <SignInBody
                            redirectToSignUp={handleRedirectToSignUp}
                            redirectToForgotPassword={handleRedirectToForgotPassword}
                        />
                    </div>
                </Row>
            </Container>
        </div>
    );
};

SignInPage.propTypes = {};

export default React.memo(SignInPage);
